<template>
  <div>
    <div class="title">
      <h3>Payment Failed - Rate Limit Exceeded</h3>
    </div>
    <div class="details">
      <p>
        The system has detected that an abnormal number of payment
        request for the invoice. This is usually a sign that someone
        it trying to complete fraudlent payments.
      </p>
      <p>
        You cannot make the payment for the transaction at this time.
        The rate limits are time based, so if this is a legitimate payment
        request, ytou can try this payment again after a short period of time.
      </p>
      <p>
        If the problem persists, please contact the site admin for further assistance.
      </p>
      <div>
        <a href="javascript:window.history.back()">Go Back</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'rate-limit-exceeded',
  props: {
    details: {
      type: Error,
      required: true
    },
    txn: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang='scss' scoped>

</style>
